// extracted by mini-css-extract-plugin
export default {"container":"PickerEmoji_container_EWcPF","title":"PickerEmoji_title_VcWYX","emojis":"PickerEmoji_emojis_IBvX4","item":"PickerEmoji_item_VX2Vh"};